import {
  StyleSheet,
} from 'react-native';
import { ifIphoneX } from 'react-native-iphone-x-helper';

export default StyleSheet.create({
  firstCrumbStyle: {
    width: 'auto',
  },
  crumbsContainerStyle: {
    ...ifIphoneX({
      marginTop: 52,
    }, {
      marginLeft: 60,
      marginTop: 14,
    }),
  },
  crumbsContainerStyleLandscape: {
    marginLeft: 60,
    marginTop: 14,
  },
});
